import React from 'react';
import Glide from "@glidejs/glide";
import styles from './sliderReview.module.scss';
import locales from "../../../../content.json"

import stars from '../img/stars.svg';
import stars4 from '../img/stars-4.svg';

const sliderConfiguration = {
  type: "carousel",
	peek: 20,
	gap: 10,
	hoverpause: true,
  autoplay: 5000,
	animationDuration: 800,
};

function SliderReview() {

  const ref = React.useRef();

  React.useEffect(() => {
    const slider = new Glide(ref.current, sliderConfiguration);
    slider.mount();
  }, [ref]);


  return (
    <div ref={ref} className={styles.glide}>
      <div className={styles.glide__track} data-glide-el="track">
        <ul className={styles.glide__slides}>
          <li className={styles.glide__slide}>
            <div className={styles.glide__slide_top}>
              <div className={styles.glide__slide_top_text}>
                <div className={styles.glide__slide_top_text_name}>
                  {locales[window.userLang].loader_review_title_3}
                </div>
                <div className={styles.glide__slide_top_text_recomends}>
                  {locales[window.userLang].loader_review_name_3}
                </div>
              </div>
            </div>
            <div className={styles.glide__slide_stars}>
              <img src={stars} alt={stars}/>
            </div>
            <div className={styles.glide__slide_bottom}>
              {locales[window.userLang].loader_review_description_3}
            </div>
          </li>
          <li className={styles.glide__slide}>
            <div className={styles.glide__slide_top}>
              <div className={styles.glide__slide_top_text}>
                <div className={styles.glide__slide_top_text_name}>
                  {locales[window.userLang].loader_review_title_4}
                </div>
                <div className={styles.glide__slide_top_text_recomends}>
                  {locales[window.userLang].loader_review_name_4}
                </div>
              </div>
            </div>
            <div className={styles.glide__slide_stars}>
              <img src={stars4} alt={stars}/>
            </div>
            <div className={styles.glide__slide_bottom}>
              {locales[window.userLang].loader_review_description_4}
            </div>
          </li>
          <li className={styles.glide__slide}>
            <div className={styles.glide__slide_top}>
              <div className={styles.glide__slide_top_text}>
                <div className={styles.glide__slide_top_text_name}>
                  {locales[window.userLang].loader_review_title_5}
                </div>
                <div className={styles.glide__slide_top_text_recomends}>
                  {locales[window.userLang].loader_review_name_5}
                </div>
              </div>
            </div>
            <div className={styles.glide__slide_stars}>
              <img src={stars} alt={stars}/>
            </div>
            <div className={styles.glide__slide_bottom}>
              {locales[window.userLang].loader_review_description_5}
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SliderReview;
